import { render, staticRenderFns } from "./credit-icon.vue?vue&type=template&id=7153d44b&"
import script from "./credit-icon.vue?vue&type=script&lang=js&"
export * from "./credit-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports